<template lang="pug">
div
  md-steppers(:md-active-step.sync="active" md-dynamic-height md-vertical md-linear)
      md-step#data(:md-label="$t('label.naam')" :md-description="horse.name" :md-done.sync="first" )
        .md-layout
          .md-layout-item.md-size-50.md-small-size-100
            data-card(@next="setDone('first','breed')" style="width:100%" @reset="reset")
      md-step#breed(:md-label="$t('label.ras')" :md-description="(breed.name || '') + ' ' + (breedType.name || '')" :md-done.sync="second")
        .md-layout.md-gutter
          .md-layout-item.md-size-25.md-medium-size-50.md-small-size-100.md-xsmall-size-100(v-for="(type,index) in breeds" :key="index")
            card-select(:id="type.classID" :title="type.name" :active.sync="selected" :img="image('breed', type.classID)" :list="type.breeds" @index="setBreedIdx(index, ...arguments)" @sel="selected=type.classID")
      md-step#weight(:md-label="$t('label.gewicht')" :md-description="horseWeight"  :md-done.sync="third" )
        .md-layout
          .md-layout-item.md-size-35.md-small-size-100.md-xsmall-size-100
            weight-card(@weight="setWeight(...arguments)")
      md-step#phase(:md-label="$t('label.phase')" :md-description="(phase.name || '') + ' ' + (phaseType.name || '')" :md-done.sync="fourth")
        .md-layout.md-gutter
          .md-layout-item.md-size-25.md-medium-size-50.md-small-size-100(v-for="(phase,index) in phases" :key="index")
            test-card(:id="phase.lifeStateID" :title="phase.name" :img="phase.img" :actions="phase.items" @index="setPhaseIdx(index, ...arguments)")
      md-step#state(:md-label="$t('label.activity')" :md-description="(activityType.name || '') + ' ' + (activity.name || '')" :md-done.sync="fifth")
        .md-layout.md-gutter
          .md-layout-item.md-size-25.md-medium-size-50.md-small-size-100(v-for="(type, index) in activities" :key="index")
            test-card(:id="type.lifeStateID" :title="type.name" :img="type.img" :actions="type.items" @index="setActivityIdx(index, ...arguments)")
          .md-layout-item.md-size-25.md-small-size-100
            low-energy-card
          .md-layout-item.md-size-25.md-small-size-100
            consumer-line-card
      md-step#advice(:md-label="$t('label.advice')" :md-done.sync="sixth")
        advice
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { START, ENABLE_TOOLBAR, SET_BREEDTYPE_IDX, SET_BREED_IDX, SET_PHASETYPE_IDX, SET_PHASE_IDX, SET_ACTIVITYTYPE_IDX, SET_ACTIVITY_IDX, SET_ACTIVITY, SET_RATION_ID, SET_RATION } from '@/constants/store'

export default {
  name: 'info',
  components: {
    DataCard: () => import('@/components/DataCard'),
    CardSelect: () => import('@/components/CardSelect'),
    TestCard: () => import('@/components/TestCard'),
    WeightCard: () => import('@/components/WeightCard'),
    ConsumerLineCard: () => import('@/components/ConsumerLineCard'),
    Advice: () => import('@/components/Advice'),
    LowEnergyCard: () => import('@/components/LowEnergyCard')
  },
  metaInfo: {
    title: 'MyCavalor Ration Advice',
    // override the parent template and just use the above title only
    titleTemplate: null
  },
  data () {
    return {
      active: 'data',
      first: false,
      second: false,
      third: false,
      fourth: false,
      fifth: false,
      sixth: false,
      selected: -1
    }
  },
  mounted () {
    this.$store.dispatch('initialize')
    this.$store.commit(ENABLE_TOOLBAR)
  },
  computed: {
    ...mapState([
      'language',
      'acceptTerms',
      'breeds',
      'breedTypeIdx',
      'breedIdx',
      'activities',
      'activityTypeIdx',
      'activityIdx',
      'phases',
      'phaseTypeIdx',
      'phaseIdx',
      'weights'
    ]),
    ...mapState({
      weightID: 'weight'
    }),
    ...mapGetters([
      'horse',
      'breedType',
      'breed',
      'weight',
      'phaseType',
      'phase',
      'activityType',
      'activity',
      'ration',
      'image'
    ]),
    breedID () {
      return (this.breed || {}).breedID
    },
    horseWeight () {
      if (this.horse.weight) {
        return '' + this.horse.weight + 'kg'
      }
      return ''
    },
    i18nLanguage () {
      return this.i18n.locale
    },
    activePage () {
      return this.$route.path
    }
  },
  methods: {
    cookieClickedAccept () {
      // console.log('accepted coookies')
    },
    reset () {
      this.active = 'data'
      this.first = false
      this.second = false
      this.third = false
      this.fourth = false
      this.fifth = false
      this.sixth = false
      this.selected = -1
      this.$store.commit(START)
    },
    async setBreedIdx (val, args) {
      await this.$store.commit(SET_BREEDTYPE_IDX, args.type)
      await this.$store.commit(SET_BREED_IDX, args.index)
      await this.$store.dispatch('getWeights', { breedID: this.breedIdx })
      /* this.$ga.event({
        eventCategory: 'breed',
        eventAction: 'select',
        eventLabel: 'breedID',
        eventValue: this.breedIdx
      }) */
      this.setDone('second', 'weight')
    },
    setWeight (args) {
      this.$store.dispatch('getPhases', { breedID: this.breedIdx, weightID: args })
      /* this.$ga.event({
        eventCategory: 'weight',
        eventAction: 'select',
        eventLabel: 'weightID',
        eventValue: args
      }) */
      this.setDone('third', 'phase')
    },
    setPhaseIdx (val, args) {
      this.$store.commit(SET_PHASETYPE_IDX, args.type)
      this.$store.commit(SET_PHASE_IDX, args.index)
      this.$store.dispatch('getStates', { breedID: this.breedIdx, weightID: this.weightID, phaseID: args.type, phaseDetailID: args.index })
      this.$store.commit(SET_ACTIVITYTYPE_IDX, -1)
      this.$store.commit(SET_ACTIVITY_IDX, -1)
      this.$store.commit(SET_ACTIVITY, {})
      this.$store.commit(SET_RATION_ID, -1)
      this.$store.commit(SET_RATION, {})
      /* this.$ga.event({
        eventCategory: 'phase',
        eventAction: 'select',
        eventLabel: 'phaseID',
        eventValue: args.index
      }) */
      this.setDone('fourth', 'state')
    },
    setActivityIdx (val, args) {
      this.$store.commit(SET_ACTIVITYTYPE_IDX, args.type)
      this.$store.commit(SET_ACTIVITY_IDX, args.index)
      this.$store.dispatch('getAdvice', { breedID: this.breedIdx, weightID: this.weightID, phaseID: this.phaseTypeIdx, phaseDetailID: this.phaseIdx, stateID: this.activityTypeIdx, stateDetailsID: this.activityIdx })
      /* this.$ga.event({
        eventCategory: 'activity',
        eventAction: 'select',
        eventLabel: 'activityID',
        eventValue: this.activityIdx
      }) */
      this.setDone('fifth', 'advice')
    },
    show (card, list, idx, length, model) {
      this.$refs[list].forEach(item => {
        item.style.opacity = 0
      })
      this.$refs[card].forEach(item => {
        item.style.opacity = 0.3
      })
      // this[model] = ''
      this.$refs[card][idx].style.opacity = 1
      this.$refs[list][idx].style.opacity = 1
      this.$refs[list][idx].parentNode.scrollTop = '-1'
    },
    setDone (id, index) {
      console.log('setDone ', id, index)
      this[id] = true
      if (index) {
        this.active = index
      }
    }
  }
}
</script>
<style>
html, body{
    height: 100vh;
    overflow: hidden;
}
.md-button {
  float: left;
}
.md-radio {
  width: 100%;
  float: left;
  text-align: left;
}
.img {
  height: 180px;
}
.md-stepper {
  background-color: #F0F3F6 !important;
  margin-top: 3px;
}
.md-layout-item {
    margin-top: 8px;
    margin-bottom: 8px;
}
.widen {
  margin-left: -44px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Info.vue